module.exports = __webpack_public_path__ + "img/products.f8d3119d.jpg";